import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { NavMenuItem } from "../../../../shared/layouts/components/NavMenuItem"
import { faHome, faBuilding, faUser } from "@fortawesome/pro-light-svg-icons"
import {
    SERVICE_CENTER_ADMIN_ACCOUNT_ADMINISTRATORS_ROUTE,
    SERVICE_CENTER_ADMIN_ACCOUNT_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_ROUTE,
    SERVICE_CENTER_ADMIN_ROUTE,
} from "../../../../constants/routes"
import { NavMenuItemGroupWrapper, NavMenuSubItem } from "../../../../shared/layouts/components/NavMenuItemGroup"

export function ServiceCenterAdminNavItems() {
    return (
        <>
            <LocalizedStrict id="service-center-nav-item-home">
                <NavMenuItem icon={faHome} dest={SERVICE_CENTER_ADMIN_ROUTE}>
                    Home
                </NavMenuItem>
            </LocalizedStrict>
            <LocalizedStrict id="service-center-admin-nav-item-organization-page-header" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper
                    isMobile
                    icon={faBuilding}
                    dest={SERVICE_CENTER_ADMIN_ORGANIZATION_ROUTE}
                    title="Organization"
                >
                    <LocalizedStrict id="service-center-admin-nav-item-organization-resources">
                        <NavMenuSubItem route={SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE}>
                            Resources
                        </NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="service-center-admin-nav-item-organization-devices">
                        <NavMenuSubItem route={SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_ROUTE}>Devices</NavMenuSubItem>
                    </LocalizedStrict>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
            <LocalizedStrict id="service-center-admin-nav-item-account-page-header" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper
                    isMobile
                    icon={faUser}
                    dest={SERVICE_CENTER_ADMIN_ACCOUNT_ROUTE}
                    title="Account"
                >
                    <LocalizedStrict id="service-center-admin-nav-item-account-administrators">
                        <NavMenuSubItem route={SERVICE_CENTER_ADMIN_ACCOUNT_ADMINISTRATORS_ROUTE}>
                            Administrators
                        </NavMenuSubItem>
                    </LocalizedStrict>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
        </>
    )
}
